import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Slider from 'react-slick';
import { useRouter } from 'next/router';
import useTranslations from '@hooks/useTranslation';
import { Photo, PhotoContainer, Photos, Wrapper } from './StaticCarouselGallery.elements';

export interface StaticCarouselGalleryProps {
    images: string[];
}

const StaticCarouselGalleryTemplate: FC<StaticCarouselGalleryProps> = ({ images }) => {
    const { t } = useTranslations();

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: false,
        responsive: [
            {
                breakpoint: 320,
                settings: { slidesToShow: 1, slidesToScroll: 1, infinite: false },
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 2, slidesToScroll: 2, infinite: false },
            },
        ],
    };

    const [imgFocus, setImgFocus] = useState(false);
    const [imgIndex, setImgIndex] = useState(0);

    return (
        images?.length > 0 && (
            <Wrapper>
                <Photos>
                    <Slider {...settings}>
                        {images?.map((image: string, key: number) => (
                            <PhotoContainer key={key}>
                                <Photo
                                    width={0}
                                    height={0}
                                    loader={({ src }: any) => src}
                                    src={image}
                                    onClick={() => {
                                        setImgIndex(key);
                                        setImgFocus(true);
                                    }}
                                />
                            </PhotoContainer>
                        ))}
                    </Slider>
                </Photos>
                {imgFocus && (
                    <Lightbox
                        mainSrc={images[imgIndex]}
                        nextSrc={images[(imgIndex + 1) % images.length]}
                        prevSrc={images[(imgIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => setImgFocus(false)}
                        onMovePrevRequest={() => setImgIndex((imgIndex + images.length - 1) % images.length)}
                        onMoveNextRequest={() => setImgIndex((imgIndex + 1) % images.length)}
                    />
                )}
            </Wrapper>
        )
    );
};

export default StaticCarouselGalleryTemplate;
